import { forwardRef } from "react"
import { useController } from "react-hook-form"
import { TextField } from "@mui/material"

function TextInput({ control, name, rules, ...textFieldProps }, ref) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
    rules,
  })

  return (
    <TextField
      {...field}
      ref={ref}
      error={invalid}
      helperText={error?.message || ""}
      {...textFieldProps}
    />
  )
}

export default forwardRef(TextInput)
